import { Button } from "@mui/material";
import { RELEASE_STAGE } from "app/utils/constants/releaseStages";

const ReleaseStageBadge = ({ stage }) => {
  if (stage !== RELEASE_STAGE.BETA) return null;

  return (
    <Button
      variant="contained"
      component="span"
      tabIndex={-1}
      sx={{
        backgroundColor: "#EA8407",
        color: "white",
        mr: 0.75,
        fontSize: "0.8rem",
        px: 1,
        py: 0.5,
        minWidth: "auto",
        textTransform: "none",
        borderRadius: "20px",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: "#EA8407",
          boxShadow: "none",
        },
      }}
    >
      Beta
    </Button>
  );
};

export default ReleaseStageBadge;
